module.exports = __webpack_public_path__ + "cff95b36156a924e41c6d1bb14f48311.pdf";